import { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Send } from 'lucide-react';

export function TaskComments({ comments = [], canComment, onAddComment }) {
  const [newComment, setNewComment] = useState('');

  const handleSubmit = () => {
    if (!newComment.trim()) return;
    onAddComment(newComment);
    setNewComment('');
  };

  return (
    <div className="mt-6">
      <Label>Comments ({comments.length})</Label>

      <div className="mt-2 space-y-3 max-h-48 overflow-y-auto">
        {comments.map(comment => (
          <div key={comment.id} className="flex gap-3">
            <div className="w-8 h-8 rounded-full bg-[#FFFF66] text-[#101010] flex items-center justify-center text-xs font-bold flex-shrink-0">
              {comment.user_initials}
            </div>
            <div className="flex-1 bg-[#F5F5F5] rounded-lg p-3">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium">{comment.user_name}</span>
                <span className="text-xs text-[#666666]">
                  {new Date(comment.created_at).toLocaleString()}
                </span>
              </div>
              <p className="text-sm mt-1">{comment.content}</p>
            </div>
          </div>
        ))}
      </div>

      {canComment && (
        <div className="flex gap-2 mt-3">
          <Input
            value={newComment}
            onChange={e => setNewComment(e.target.value)}
            placeholder="Add a comment..."
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            data-testid="comment-input"
          />
          <Button onClick={handleSubmit} size="icon" data-testid="send-comment">
            <Send size={16} />
          </Button>
        </div>
      )}
    </div>
  );
}
